export default class BtnLoader {
  constructor (btnId) {
    this.btnId = btnId
    this.defaultText = document.getElementById(btnId).textContent
  }

  show () {
    document.getElementById(this.btnId).textContent = ''
    let img = document.createElement('img')
    img.src = '/assets/img/loader.gif'
    img.height = 30
    let to = document.getElementById(this.btnId)
    to.appendChild(img)
  }

  hide () {
    document.getElementById(this.btnId).textContent = this.defaultText
  }
}
